// src/services/api/offlineSales/customerPayments.js
// Endpoints per rettzy-backend/src/modules/offlineSales/routes/customerPayment.routes.js
import { apiClient } from '../base';

export const getCustomerPayments = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/customer-payments', { params });
  return response.data;
};

export const getCustomerPayment = async (id) => {
  const response = await apiClient.get(`/offline-sales/customer-payments/${id}`);
  return response.data;
};

export const previewCustomerPaymentAllocation = async (customerId, amount = 0) => {
  const response = await apiClient.post('/offline-sales/customer-payments/preview', { customerId, amount });
  return response.data;
};

export const createCustomerPayment = async (data) => {
  const response = await apiClient.post('/offline-sales/customer-payments', data);
  return response.data;
};

export const voidCustomerPayment = async (id, reason = '') => {
  const response = await apiClient.post(`/offline-sales/customer-payments/${id}/void`, { reason });
  return response.data;
};
